module.exports = __webpack_public_path__ + "img/gn_02.845bf4ef.png";